module.exports = __webpack_public_path__ + "media/application/images/icons/topics-environment-pebble-dark-green-rgb-697cdce7f3cf92d68a6b8af732874c49.svg";